__turbopack_context__.v({
  "button": "style-module-scss-module__Sl5G6a__button",
  "buttonWrapper": "style-module-scss-module__Sl5G6a__buttonWrapper",
  "disabledSliderWrapper": "style-module-scss-module__Sl5G6a__disabledSliderWrapper",
  "head": "style-module-scss-module__Sl5G6a__head",
  "line": "style-module-scss-module__Sl5G6a__line",
  "slideWrapper": "style-module-scss-module__Sl5G6a__slideWrapper",
  "sliderWrapper": "style-module-scss-module__Sl5G6a__sliderWrapper",
  "title": "style-module-scss-module__Sl5G6a__title",
  "wrapper": "style-module-scss-module__Sl5G6a__wrapper",
});
